import React from "react";
import { useSelector } from "react-redux";
import BillAndExpenseReport from "./BillAndExpenseReport";

const Report = () => {
  const report = useSelector((state) => state.auth?.reportType);
  switch (report?.value?.toLowerCase()) {
    case "bill and expense report":
      return <BillAndExpenseReport />;
    default:
      return (
        <div className="text-center my-3 fw-medium">Please select a report</div>
      );
  }
};

export default Report;
